<template>
  <modal-component :back="back">
    <div class="modal-container2">
      <div class="left">
        <div>
          <div class="white-card" style="min-height: 300px">
            <div class="loader absolute" v-if="loading"></div>
            <template v-else-if="exercise">
              <h4 class="text-green m-0">{{ exercise.title }}</h4>
              <hr class="my-2">
              <div class="top" style="min-height: 300px">
                <div class="html-content" v-if="!exercise.resume_pdf" v-html="exercise.resume"></div>
                <div v-else>
                  <image-list :images="exercise.resume_images"/>
                </div>
              </div>
              <div class="d-flex mt-3 align-items-center justify-content-center">
                <button class="btn btn-sm text-green" @click="()=>showSolution=!showSolution">
                  <i class="ti-eye"> </i>
                  {{ showSolution ? 'Cacher la solution' : 'Afficher la solution' }}
                </button>
              </div>
            </template>
          </div>
          <div class="mt-3 white-card solution" v-if="exercise && showSolution">
            <div class="html-content" v-if="!exercise.solution_pdf" v-html="exercise.solution"></div>
            <div v-else>
              <image-list :images="exercise.solution_images"/>
            </div>
            <VideoPlayer v-if="exercise.video" :video="exercise.video"/>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right" v-if="discussion_id">
          <chat-widget :discussion-id="discussion_id" class="fixed"></chat-widget>
        </div>
      </div>
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "../../components/LayoutPartials/ModalComponent";
import axios from 'axios'
import ChatWidget from "@/components/Chat/ChatWidget";
import VideoPlayer from "@/components/VideoPlayer";
import ImageList from "@/components/Lesson/ImageList";

export default {
  name: "ExerciseView",
  components: {ImageList, ChatWidget, ModalComponent, VideoPlayer},
  data() {
    return {
      exercise: null,
      showSolution: false,
      loading: false,
      discussion_id: null,
      back: {
        name: 'lesson-exercises',
        params: {slug: this.$route.params.lesson_slug}
      }
    }
  },
  mounted() {
    this.loading = true
    axios.get('/lesson/exercise/' + this.$route.params.id)
      .then(({data}) => {
        this.exercise = data.exercise
        this.discussion_id = data.discussion_id
      })
      .finally(() => this.loading = false)
  }
}
</script>

<style scoped lang="scss">
.border-gray {
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}

.solution {
  border-top: 5px solid $green;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
</style>
